// extracted by mini-css-extract-plugin
export var restrictedWidthButton = "_nd-0";